import React, { useEffect } from 'react'
import { useTranslation } from 'i18n'
import './UploadProgressBar.scss'

const UploadProgressBar = ({ percent }) => {
  const { t } = useTranslation('ugcMediaUpload')
  const progressStyle = {
    width: `${percent}%`,
  }

  useEffect(() => {
    console.log(`percent`, percent)
  }, [percent])
  return (
    <>
      <div className={`uploaded-video-item-uploadbar-wrapper`}>
        <div className={`uploaded-video-item-uploadbar-text`}>
          {percent < 100 ? t('upload.uploading') : t('upload.uploaded')}
        </div>
        <div className={`uploaded-video-item-uploadbar`}>
          <div className={`uploaded-video-item-uploadbar-progress-percent`}>
            {percent}%
          </div>
          <div
            className={`uploaded-video-item-uploadbar-progress`}
            style={progressStyle}
          ></div>
        </div>
      </div>
    </>
  )
}

export default UploadProgressBar
